import { useDispatch, useSelector } from "react-redux";
import {
  IonAvatar,
  IonCard,
  IonIcon,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonSearchbar,
  IonText,
} from "@ionic/react";
import { selectUserRoles } from "../../../store/locationShow/selectors/selectUserRoles";
import { setUserRolesSearchText } from "../../../store/locationShow";
import { selectUserRolesSearchText } from "../../../store/locationShow/selectors/selectUserRolesSearchText";
import UserAvatar from "../../../components/UserAvatar";
import { bagOutline } from "ionicons/icons";
export const UserRolesSection: React.FC = () => {
  const dispatch = useDispatch();
  const userRoles = useSelector(selectUserRoles);
  const searchText = useSelector(selectUserRolesSearchText);

  const supervisorRole = userRoles.find(({ role }) => role?.id == "1");
  const allRoles = userRoles.filter(({ role }) => role?.id != "1");

  const PrintItem = ({ userRoleItem }: any) => (
    <IonCard
      key={userRoleItem.id}
      class="ion-no-padding"
      routerLink={`/app/supervision/colaborador/${userRoleItem.user?.id}`}
    >
      <IonItem lines="none" button>
        <UserAvatar user={userRoleItem.user} />
        <IonLabel>
          <h2 style={{ fontWeight: 500 }}>{userRoleItem.user?.name}</h2>
          <p>
            <IonIcon icon={bagOutline}></IonIcon>
            <span className="ion-margin-start">{userRoleItem.role?.name || "--"}</span>
          </p>
        </IonLabel>
      </IonItem>
    </IonCard>
  );

  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">Colaboradores ({userRoles.length})</IonText>
      </h2>

      <IonSearchbar
        style={{ maxWidth: 360 }}
        placeholder="Buscar colaborador"
        value={searchText}
        onIonChange={({ detail: { value = "" } }) => dispatch(setUserRolesSearchText(value))}
        class="ion-no-padding ion-padding-start ion-padding-bottom"
      ></IonSearchbar>

      {userRoles.length === 0 ? (
        <IonItem lines="none">
          <IonLabel>
            <IonText color="medium">No se han encontrado colaboradores</IonText>
          </IonLabel>
        </IonItem>
      ) : (
        <>
          <IonItemDivider>Supervisor</IonItemDivider>
          {supervisorRole && <PrintItem userRoleItem={supervisorRole} />}

          <IonItemDivider>Colaboradores</IonItemDivider>
          {allRoles.map((userRoleItem, index) => (
            <PrintItem key={`item-${index}`} userRoleItem={userRoleItem} />
          ))}
        </>
      )}
    </>
  );
};
